export enum Relationship { 
    Father=1,
    Mother=2,
    LegalGuardian=3,
     StepFather=4, 
     StepMother=5, 
     Grandfather=6, 
     Grandmother=7, 
     Other=8
}